import { Plugin, ButtonView } from 'ckeditor5';

export default class ReadMoreUI extends Plugin {
    init() {
        const editor = this.editor;

        editor.ui.componentFactory.add('readMore', locale => {
            const button = new ButtonView(locale);

            button.set({
                label: 'Read More',
                icon: `<?xml version="1.0" encoding="utf-8"?><svg width="50px" height="50px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect x="0" fill="none" width="24" height="24"/><g><path d="M9 12h6v-2H9zm-7 0h5v-2H2zm15 0h5v-2h-5zm3 2v2l-6 6H6a2 2 0 0 1-2-2v-6h2v6h6v-4a2 2 0 0 1 2-2h6zM4 8V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4h-2V4H6v4z"/></g></svg>`,
                tooltip: true
            });

            button.on('execute', () => {
                editor.execute('insertReadMore');
            });

            return button;
        });
    }
}
